import React from 'react'
import { Box, TextField, Typography } from '@material-ui/core'
import CardTitle from '../../../components/sharedComponents/CardTitle/index'
import TablePostVenta from '../../../components/reports/postVenta/TablePostVenta'
import TablePostVentaFiltered from '../../../components/reports/postVenta/TablePostVentaFiltered'
import { Button, useStyles } from './styles'

const PostVenta = (props) => {
  const {
    spareParts,
    sparePartsFiltered,
    onChangeInput,
    onSubmitEmail,
    onSubmitSearch,
    onSubmitfiltered,
  } = props

  const columns = [
    { title: 'Linea', field: 'linea' },
    { title: 'Descripción', field: 'descripcion' },
    { title: 'Cantidad/unidades', field: 'cantidad' },
    { title: 'Referencia', field: 'referencia' },
    { title: 'Material', field: 'material' },
    { title: 'Infaltable', field: 'infaltable' },

  ]

  const columnsFiltered = [
    { title: 'Codigo', field: 'CodigoEstablecimiento' },
    { title: 'Establecimiento', field: 'Establecimiento' },
  ]
  const classes = useStyles()

  return (
    <>
      <CardTitle title="Buscador de repuestos postventa C.S.A" />
      <Box
        component="form"
        onSubmit={onSubmitfiltered}
        className={classes.formContainer}
      >
        <TextField
          type="text"
          className={classes.input}
          label="nombre CSA"
          required
          variant="outlined"
          onChange={(e) => {
            onChangeInput(e.target.value, 'searchs')
          }}
        />
        <Button type="submit">Buscar</Button>
      </Box>

      {sparePartsFiltered ? (
        <TablePostVentaFiltered
          title="CSA"
          dataTable={sparePartsFiltered}
          columns={columnsFiltered}
        />
      ) : (
        <></>
      )}

      <Box
        component="form"
        onSubmit={onSubmitSearch}
        className={classes.formContainer}
      >
        <TextField
          type="text"
          className={classes.input}
          label="Código SAP"
          required
          variant="outlined"
          onChange={(e) => {
            onChangeInput(e.target.value, 'search')
          }}
        />
        <Button type="submit">Buscar</Button>
      </Box>
      <TablePostVenta
        title="Repuestos"
        dataTable={spareParts}
        columns={columns}
      />

      {spareParts.length > 0 ? (
        <>
          <Typography className={classes.text}>
            Si desea recibir el anterior listado escriba su email en el
            siguiente campo
          </Typography>
          <Box
            component="form"
            onSubmit={onSubmitEmail}
            className={classes.formEmail}
          >
            <TextField
              type="email"
              className={classes.input}
              label="Email"
              required
              variant="outlined"
              onChange={(e) => {
                onChangeInput(e.target.value, 'send')
              }}
            />
            <Button type="submit">Enviar Email</Button>
          </Box>
        </>
      ) : null}
    </>
  )
}

export default PostVenta
